import { createAction, props } from "@ngrx/store";
import { IErrors } from "../../models/error";
import { IBook, IChapter, IPagesResponse, IResponse, IPage, ILayout, ILayoutList, IEditorChaptersResponse, IChapterUpdateResponse, ICreateChapterRequest, IDeleteSubChapterResponse, IBookUpdateResponse } from "../../models/admin";
import { IGetAllOrdersRequest, IOrderInfoPagedResult } from "../../models/Subscription";


enum AdminActions {
    // Books
    GetEditorBooks = '[Admin] Get Editor Books',
    GetEditorBooksSuccess = '[Admin] Get Editor Books Succcess',
    GetEditorBooksFailure = '[Admin] Get Editor Books Failure',
    AddBook = '[Admin] Add Book',
    AddBookSuccess = '[Admin] Add Book Success',
    AddBookFailure = '[Admin] Add Book Failure',
    UpdateBook = '[Admin] Update Book',
    UpdateBookSuccess = '[Admin] Update Book Success',
    UpdateBookFailure = '[Admin] Update Book Failure',
    DeleteBook = '[Admin] Delete Book',
    DeleteBookSuccess = '[Admin] Delete Book Success',
    DeleteBookFailure = '[Admin] Delete Book Failure',

    // Chapters
    GetEditorChapters = '[Admin] Get Editor Chapters',
    GetEditorChaptersSuccess = '[Admin] Get Editor Chapters Success',
    GetEditorChaptersFailure = '[Admin] Get Editor Chapters Failure',
    DeleteChapter = '[Admin] Delete Chapter',
    DeleteChapterSuccess = '[Admin] Delete Chapter Success',
    DeleteChapterFailure = '[Admin] Delete Chapter Failure',

    // Update Chapter
    UpdateChapter = '[Admin] Update Chapter',
    UpdateChapterSuccess = '[Admin] Update Chapter Success',
    UpdateChapterFailure = '[Admin] Update Chapter Failure',

    // Pages
    GetEditorPages = '[Admin] Get Editor Pages',
    GetEditorPagesSuccess = '[Admin] Get Editor Pages Success',
    GetEditorPagesFailure = '[Admin] Get Editor Pages Failure',
    AddPage = '[Admin] Add Page',
    AddPageSuccess = '[Admin] Add Page Success',
    AddPageFailure = '[Admin] Add Page Failure',

    // Delete Page
    DeletePage = '[Admin] Delete Page',
    DeletePageSuccess = '[Admin] Delete Page Success',
    DeletePageFailure = '[Admin] Delete Page Failure',

    // Update Page
    UpdatePage = '[Admin] Update Page',
    UpdatePageSuccess = '[Admin] Update Page Success',
    UpdatePageFailure = '[Admin] Update Page Failure',

    // layout related action

    GetLayoutsAction = '[Admin] Get Layouts Action',
    GetLayoutsSuccessAction = '[Admin] Get Layouts Success',
    GetLayoutsFailureAction = '[Admin] Get Layouts Failure',
    DeleteLayout = '[Admin] Delete Layout',
    DeleteLayoutSuccess = '[Admin] Delete Layout Success',
    DeleteLayoutFailure = '[Admin] Delete Layout Failure',
    AddGlobalLayout = '[Admin] Add Global Layout',
    AddGlobalLayoutSuccess = '[Admin] Add Global Layout Success',
    AddGlobalLayoutFailure = '[Admin] Add Global Layout Failure',

    // SubChapters
    FetchSubchapters = '[Admin] Fetch SubChapters',
    FetchSubchaptersSucces = '[Admin] Fetch SubChapters Success',
    FetchSubChaptersFailure = '[Admin] Fetch SubChapters Failure',

    // Add SubChapter
    AddSubChapter = '[Admin] Add SubChapter',
    AddSubChapterSuccess = '[Admin] Add SubChapter Success',
    AddSubChapterFailure = '[Admin] Add SubChapter Failure',

    // Delete SubChapter
    DeleteSubChapter = '[Admin] Delete SubChapter',
    DeleteSubChapterSucces = '[Admin] Delete SubChapter Success',
    DeleteSubChapterFailure = '[Admin] Delete SubChapter Failure',

    // Release Book
    ReleaseBook = '[Admin] Release Book',
    ReleaseBookSuccess = '[Admin] Release Book Success',
    ReleaseBookFailure = '[Admin] Release Book Failure',

    // Fetch Orders
    FetchOrders = '[Admin] Fetch Orders',
    FetchOrdersSuccess = '[Admin] Fetch Orders Success',
    FetchOrdersFailure = '[Admin] Fetch Orders Failure',

    // Clear Orders
    ClearOrdersState = '[Admin] Clear Orders',
    // Update Pagination State
    AdminUpdateOrdersPagination = '[Admin] Update Orders Pagination',

    // Reorder Books
    ReorderBookSuccess = '[Admin] Reorder Book Success',
    ReorderBookFailure = '[Admin] Reorder Book Failure',

    // Reorder Chapter
    ReorderChapterSuccess = '[Admin] Reorder Chapter Success',
    ReorderChapterFailure = '[Admin] Reorder Chapter Failure',

    // Reorder Page
    ReorderPageSuccess = '[Admin] Reorder Page Success',
    ReorderPageFailure = '[Admin] Reorder Page Failure',

    // Reorder Topic
    ReorderTopicSuccesss = '[Admin] Reorder Topic Success',
    ReorderTopicFailure = '[Admin] Reorder Topic Failure',
}

// Editor Books
export const GetEditorBooksAction = createAction(AdminActions.GetEditorBooks);
export const GetEditorBooksSuccessAction = createAction(
    AdminActions.GetEditorBooksSuccess,
    props<{ response: IPagesResponse<IBook> }>()
)
export const GetEditorBooksFailureAction = createAction(
    AdminActions.GetEditorBooksFailure,
    props<{ error: IErrors }>()
)

export const AddBookAction = createAction(
    AdminActions.AddBook,
    props<{ book: Partial<IBook> }>()
)

export const AddBookSuccessAction = createAction(
    AdminActions.AddBookSuccess,
    props<{
        response: {
            Value: IBook,
            errors: IErrors[]
        }
    }>()
)

export const AddBookFailureAction = createAction(
    AdminActions.AddBookFailure,
    props<{ error: IErrors }>()
)

// Update Book Actions
export const UpdateBookAction = createAction(
    AdminActions.UpdateBook,
    props<{ bookId: string, updatedFields: Partial<IBook> }>()
)
export const UpdateBookSuccessAction = createAction(
    AdminActions.UpdateBookSuccess,
    props<{ response: IBookUpdateResponse, parentChapterId?: string | null }>()
)
export const UpdateBookFailureAction = createAction(
    AdminActions.UpdateBookFailure,
    props<{ error: IErrors }>()
)

// Delete Book Actions
export const DeleteBookAction = createAction(
    AdminActions.DeleteBook,
    props<{ bookId: string }>()
)

export const DeleteBookSuccessAction = createAction(
    AdminActions.DeleteBookSuccess,
    props<{
        response: {
            Value: boolean,
            errors: IErrors[]
        }
    }>()
)

export const DeleteBookFailureAction = createAction(
    AdminActions.DeleteBookFailure,
    props<{
        response: {
            Value: boolean,
            errors: IErrors[]
        }
    }>()
)

// Editor Chapters
export const GetEditorChaptersAction = createAction(
    AdminActions.GetEditorChapters,
    props<{ bookId: string }>()
);

export const GetEditorChaptersSuccessAction = createAction(
    AdminActions.GetEditorChaptersSuccess,
    props<{ parentId: string, chapters: IChapter[] }>()
);

export const GetEditorChaptersFailureAction = createAction(
    AdminActions.GetEditorChaptersFailure,
    props<{ error: any }>()
);

export const DeleteChapterAction = createAction(
    AdminActions.DeleteChapter,
    props<{ bookId: string, chapterId: string }>()
);

export const DeleteChapterSuccessAction = createAction(
    AdminActions.DeleteChapterSuccess,
    props<{ chapterId: string }>()
);

export const DeleteChapterFailureAction = createAction(
    AdminActions.DeleteChapterFailure,
    props<{ error: any }>()
);

// Editor Pages
export const GetEditorPagesAction = createAction(
    AdminActions.GetEditorPages,
    props<{ chapterId: string }>()
);

export const GetEditorPagesSuccessAction = createAction(
    AdminActions.GetEditorPagesSuccess,
    props<{ chapterId: string, pages: IPage[] }>()
);

export const GetEditorPagesFailureAction = createAction(
    AdminActions.GetEditorPagesFailure,
    props<{ error: any }>()
);

export const AddPageAction = createAction(
    AdminActions.AddPage,
    props<{ chapterId: string, page: IPage }>()
);

export const AddPageSuccessAction = createAction(
    AdminActions.AddPageSuccess,
    props<{
        response: {
            Value: IPage,
            chapterId: string,
            errors: IErrors[]
        }
    }>()
);

export const AddPageFailureAction = createAction(
    AdminActions.AddPageFailure,
    props<{
        response: {
            Value: IPage,
            errors: IErrors[]
        }
    }>()
);

export const DeletePageAction = createAction(
    AdminActions.DeletePage,
    props<{ chapterId: string, pageId: string }>()
);

export const DeletePageSuccessAction = createAction(
    AdminActions.DeletePageSuccess,
    props<{ pageId: string, chapterId: string }>()
);

export const DeletePageFailureAction = createAction(
    AdminActions.DeletePageFailure,
    props<{ error: IErrors }>()
);

export const UpdatePageAction = createAction(
    AdminActions.UpdatePage,
    props<{
        page: Partial<IPage> & {
            PageId: string;
            chapterId: string;
        }
    }>()
);

export const UpdatePageSuccessAction = createAction(
    AdminActions.UpdatePageSuccess,
    props<{ page: IPage }>()
);

export const UpdatePageFailureAction = createAction(
    AdminActions.UpdatePageFailure,
    props<{ error: IErrors }>()
);

//layout related actions 
export const GetLayoutsAction = createAction(
    AdminActions.GetLayoutsAction
);

export const GetLayoutsSuccessAction = createAction(
    AdminActions.GetLayoutsSuccessAction,
    props<{ layouts: ILayoutList[] }>()
);

export const GetLayoutsFailureAction = createAction(
    AdminActions.GetLayoutsFailureAction,
    props<{ error: any }>()
);

export const DeleteLayoutAction = createAction(
    AdminActions.DeleteLayout,
    props<{ layoutId: string }>()
);

export const DeleteLayoutSuccessAction = createAction(
    AdminActions.DeleteLayoutSuccess,
    props<{ layoutId: string }>()
);

export const DeleteLayoutFailureAction = createAction(
    AdminActions.DeleteLayoutFailure,
    props<{
        response: {
            Value: {
                layoutId: string
            },
            errors: IErrors[]
        }
    }>()
);


export const AddGlobalLayoutAction = createAction(
    AdminActions.AddGlobalLayout,
    props<{ layout: ILayout }>()
);

export const AddGlobalLayoutSuccessAction = createAction(
    AdminActions.AddGlobalLayoutSuccess,
    props<{ layout: ILayoutList }>()
);

export const AddGlobalLayoutFailureAction = createAction(
    AdminActions.AddGlobalLayoutFailure,
    props<{ error: IErrors[] }>()
);

// SubChapters
export const FetchSubChaptersAction = createAction(
    AdminActions.FetchSubchapters,
    props<{ chapterId: string }>()
)
export const FetchSubChaptersSuccesAction = createAction(
    AdminActions.FetchSubchaptersSucces,
    props<{ response: IEditorChaptersResponse, chapterId: string }>()
)
export const FetchSubChaptersFailureAction = createAction(
    AdminActions.FetchSubChaptersFailure,
    props<{ error: IErrors }>()
)

// Update Chapter
export const UpdateChapterAction = createAction(
    AdminActions.UpdateChapter,
    props<{ chapterId: string, updatedFields: Partial<IChapter>, parentChapterId?: string | null }>()
)
export const UpdateChapterSuccessAction = createAction(
    AdminActions.UpdateChapterSuccess,
    props<{ response: IChapterUpdateResponse, parentChapterId?: string | null }>()
)
export const updateChapterFailureAction = createAction(
    AdminActions.UpdateChapterFailure,
    props<{ error: IErrors }>()
)
// Add SubChapter
export const AddSubChapterAction = createAction(
    AdminActions.AddSubChapter,
    props<{ chapterId: string, subChapterInfo: ICreateChapterRequest }>()
)
export const AddSubChapterSuccessAction = createAction(
    AdminActions.AddSubChapterSuccess,
    props<{ response: IResponse<IChapter>, parentChapterId: string }>()
)
export const AddSubChapterFailureAction = createAction(
    AdminActions.AddSubChapterFailure,
    props<{ error: IErrors }>()
)
// Delete SubChapter
export const DeleteSubChapterAction = createAction(
    AdminActions.DeleteSubChapter,
    props<{ subChapterId: string, parentChapterId: string }>()
)
export const DeleteSubChapterSuccesAction = createAction(
    AdminActions.DeleteSubChapterSucces,
    props<{ response: IDeleteSubChapterResponse, parentChapterId: string }>()
)
export const DeleteSubChapterFailureAction = createAction(
    AdminActions.DeleteSubChapterFailure,
    props<{ error: IErrors }>()
)

// Release Book
export const ReleaseBookAction = createAction(
    AdminActions.ReleaseBook,
    props<{ bookId: string }>()
);
export const ReleaseBookSuccessAction = createAction(
    AdminActions.ReleaseBookSuccess,
    props<{ response: IResponse<string> }>()
)
export const ReleaseBookFailureAction = createAction(
    AdminActions.ReleaseBookFailure,
    props<{ error: IErrors }>()
)

// Fetch Admin Orders
export const AdminFetchOrdersAction = createAction(
    AdminActions.FetchOrders,
    props<{ request: IGetAllOrdersRequest }>()
);
export const AdminFetchOrdersSuccessAction = createAction(
    AdminActions.FetchOrdersSuccess,
    props<{
        response: IOrderInfoPagedResult, paymentStatus?: string, orderStatus?: string,
        search?: string, planid?: string, dateFrom?: string, dateTo?: string
    }>()
);
export const AdminFetchOrdersFailureAction = createAction(
    AdminActions.FetchOrdersFailure,
    props<{ error: IErrors }>()
)
export const AdminClearOrdersStateAction = createAction(
    AdminActions.ClearOrdersState
)
export const AdminUpdateOrdersPaginationnAction = createAction(
    AdminActions.AdminUpdateOrdersPagination,
    props<{ pageNumber: number; pageSize: number }>()
)

// Reorder Book
export const ReorderBookSuccessAction = createAction(
    AdminActions.ReorderBookSuccess
);
export const ReorderBookFailureAction = createAction(
    AdminActions.ReorderBookFailure
);

// Reorder Chapter
export const ReorderChapterSuccessAction = createAction(
    AdminActions.ReorderChapterSuccess
);
export const ReorderChapterFailureAction = createAction(
    AdminActions.ReorderChapterFailure
);

// Reorder Page
export const ReorderPageSuccessAction = createAction(
    AdminActions.ReorderPageSuccess
);
export const ReorderPageFailureAction = createAction(
    AdminActions.ReorderPageFailure
);

// Reorder Topic
export const ReorderTopicSuccessAction = createAction(
    AdminActions.ReorderTopicSuccesss
);
export const ReorderTopicFailureAction = createAction(
    AdminActions.ReorderTopicFailure
);
